export default __webpack_public_path__ + "static/media/logo.bc6e9893.svg";